import { InputNumber, Form, Row, Col } from "antd";

export default () => {
  return (
    <Form.Item label="Margin">
      <Row gutter={8}>
        <Col span={12}>
          <Form.Item name="marginTop">
            <InputNumber
              prefix="Top:"
              min={0}
              max={60}
              step={5}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="marginRight">
            <InputNumber
              prefix="Right:"
              min={0}
              max={60}
              step={5}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="marginBottom">
            <InputNumber
              prefix="Bottom:"
              min={0}
              max={60}
              step={5}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="marginLeft">
            <InputNumber
              prefix="Left:"
              min={0}
              max={60}
              step={5}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form.Item>
  );
};
